export default __webpack_public_path__ + "static/media/login-hot-logo.e651bec8.jpg";